import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useIntl } from 'react-intl'
import { Container, IconCross, SVGContainer } from '../../../Global'
import StyledPill from '../../../Pills/StyledPill'
import {
  selectReportingFilters,
  setStatus,
} from '../../../../store/reportingFilters'
import { setRefreshChart } from '../../../../store/refreshChart'
import { setRefreshTable } from '../../../../store/refreshTable'

export const StatusPill = ({ onClick }: { onClick: () => void }) => {
  const dispatch = useDispatch()
  const intl = useIntl()

  const { status: reportingStatus } = useSelector(selectReportingFilters)
  const statusArray = reportingStatus || []
  const title = intl.formatMessage({
    id: 'reporting.filter.filter.pill.status',
  })

  const translatedStatuses = statusArray.map((st) =>
    intl.formatMessage({ id: st.toLowerCase() })
  )
  const statusTranslation = translatedStatuses.join(', ')
  const truncatedStatusTranslation =
    translatedStatuses.length > 1
      ? `${translatedStatuses[0]}, +${translatedStatuses.length - 1}`
      : translatedStatuses[0] || ''

  const onClearStatus = () => {
    dispatch(setStatus({ status: undefined }))
    dispatch(setRefreshTable({ refreshTable: true }))
    dispatch(setRefreshChart({ refreshChart: true }))
  }

  return statusArray.length > 0 ? (
    <Container display="flex" columnGap="var(--gutter-1x)" alignItems="center">
      <Container position="relative" key="status">
        <StyledPill
          isVisible
          pillId="status"
          data={{
            title: `${title}: ${truncatedStatusTranslation}`,
          }}
          tooltipText={statusTranslation}
          showTooltip={statusArray.length > 1 || statusTranslation.length > 15}
          suffix={
            <SVGContainer fontSize="var(--font-size-xs)">
              <IconCross />
            </SVGContainer>
          }
          onClear={() => onClearStatus()}
          onClick={() => onClick()}
          badgeSize={{
            height: '35px',
            maxWidth: '175px',
          }}
          badgeBackground="#7d7d7d"
          dataTestId="reporting-filter-status-pill"
        />
      </Container>
    </Container>
  ) : null
}
